import { useTheme } from '../../../../../theming/useTheme';
import { componentConfigThemeKey, HeaderWithSubMenusThemeProps } from './HeaderWithSubMenus.theme';
import { HeaderHeights } from '../header.utils';

export const useHeaderHeights = () => {
  const themeContextForHeaderWithSubMenus = useTheme<HeaderWithSubMenusThemeProps>(componentConfigThemeKey);
  return {
    large: themeContextForHeaderWithSubMenus.firstRowHeightInLargeScreen,
    medium: themeContextForHeaderWithSubMenus.firstRowHeightInMediumScreen + themeContextForHeaderWithSubMenus.secondRowHeightInMediumScreen,
    small: themeContextForHeaderWithSubMenus.firstRowHeightInSmallScreen + themeContextForHeaderWithSubMenus.secondRowHeightInSmallScreen,
  } as HeaderHeights;
};

export const useFirstRowHeaderHeights = () => {
  const themeContextForHeaderWithSubMenus = useTheme<HeaderWithSubMenusThemeProps>(componentConfigThemeKey);
  return {
    large: themeContextForHeaderWithSubMenus.firstRowHeightInLargeScreen,
    medium: themeContextForHeaderWithSubMenus.firstRowHeightInMediumScreen,
    small: themeContextForHeaderWithSubMenus.firstRowHeightInSmallScreen,
  } as HeaderHeights;
};
